import appApi from "@/api/appApi";
import { toQueryString } from "@utils/queries";

export default {
  async getList(params) {
    const queryString = toQueryString(params);
    const { data } = await appApi.get(`/news/news?${queryString}`);

    const pagination = {
      nextPage: data.data.nextPage,
      currentOffset: +data.data.currentOffset,
      offset: data.data.offset
    };

    data.pagination = pagination;

    //handle incorrect server answer
    delete data.data.currentOffset;
    delete data.data.nextPage;
    delete data.data.offset;

    data.data = Object.values(data.data);

    return data;
  },

  async getOne(slug) {
    const { data } = await appApi.get(`/news/view?id=${slug}`);
    return data;
  }
};
